import { useState } from "react";
import { X } from "lucide-react";
import { RelationshipPicker, cleanLabel, labelError } from "@/components/RelationshipPicker";
import { apiError } from "@/lib/api";
import { toast } from "sonner";

const pill = (active) => `h-11 px-4 rounded-full border text-sm transition-colors ${active ? "gold-btn" : "ghost-gold"}`;

// Edit a saved relationship (kind="rel") or the storyteller's own label (kind="role").
export const LabelEditModal = ({ title, intro, options, initial, kind, inputLabel, placeholder, onSave, onClose, testid }) => {
  const [value, setValue] = useState(initial || "");
  const [saving, setSaving] = useState(false);
  const save = async () => {
    const err = labelError(value, kind);
    if (err) return toast.error(err);
    setSaving(true);
    try { await onSave(cleanLabel(value)); onClose(); }
    catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div className="glass-card p-6 sm:p-8 max-w-md w-full max-h-[calc(100dvh-2rem)] overflow-y-auto fade-up"
        onClick={(e) => e.stopPropagation()} data-testid={testid} role="dialog" aria-modal="true">
        <div className="flex items-center justify-between mb-1">
          <h3 className="font-serif text-3xl text-[#EDE6F7]">{title}</h3>
          <button onClick={onClose} aria-label="Close" data-testid={`${testid}-close`} className="text-[#8C84A0] hover:text-[#EDE6F7]"><X className="h-6 w-6" /></button>
        </div>
        <p className="text-[#B9B3C8] mb-6">{intro}</p>
        <RelationshipPicker options={options} value={value} onChange={(v) => setValue(v)} testid={`${testid}-picker`} pill={pill}
          errorKind={kind} inputLabel={inputLabel} placeholder={placeholder} />
        <button data-testid={`${testid}-save`} onClick={save} disabled={saving}
          className="gold-btn w-full h-14 rounded-full text-lg mt-8 disabled:opacity-60">
          {saving ? "Saving…" : "Save change"}
        </button>
      </div>
    </div>
  );
};
